import React from "react";

import { Row, Col, Label } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import classNames from "classnames";

import { ServiceCallerProps } from "../../composition";
import { IChat } from "../../../types/IMessage";
import { getLastMessageDate, formatPhoneNumber, stripLeadingLineBreaks } from "../../../utils/helpers";

import s from "./styles.scss";

interface Props extends ServiceCallerProps {
  chat: IChat;
  charityName: string;
  index: number;
  isSelected: boolean;
  unreadMessages: boolean;

  onClick: (chat: IChat) => void;
}

class ChatRow extends React.PureComponent<Props> {
  handleClick = (): void => {
    this.props.onClick(this.props.chat);
  };

  render() {
    const { chat, index, isSelected, unreadMessages } = this.props;

    return (
      <Row
        className={classNames(s.row, s.bottomBorder, isSelected && s.selected)}
        onClick={this.handleClick}
        key={"chat_" + index}
      >
        <Col xs="auto" className={s.unreadCol}>
          <div className={unreadMessages ? s.unread : s.unreadSpace} />
        </Col>
        <Col xs="auto" className={s.iconCol}>
          <i className={"fas fa-user-circle " + s.userIcon + " " + s.photo} />
        </Col>
        <Col className={s.mainCol}>
          <div className={s.headerLine}>
            <Label
              className={classNames(
                s.bold,
                s.phoneNumber,
                s.preventDefaultCursor
              )}
            >
              {formatPhoneNumber(chat.donor.phoneNumber) || "Phone Unavailable"}
              {chat.donor.name && "  -  " + chat.donor.name}
            </Label>
            <span className={s.spanDate}>{getLastMessageDate(chat)}</span>
          </div>
          <Label className={classNames(s.lastMessage, s.preventDefaultCursor)}>
            {stripLeadingLineBreaks(chat.messageList[0].content)}
          </Label>
        </Col>
      </Row>
    );
  }
}

export default withStyles(s)(ChatRow);
